<template>
    <div class="form" id="form">
        <h1 class="title" v-if="isTitle">{{$t('fromData.contact')}}</h1>
        <ElForm
                label-position="top"
                :model="clientInfo"
                :rules="clientRules"
                class="demo-form-inline"
                ref="clientInfo"
        >
            <ElRow :gutter="20">
                <ElCol :xs="{span:20,push:2}" :sm="12" :md="12" :lg="12" :xl="12">
                    <ElFormItem :label="$t('fromData.name')" prop="name">
                        <ElInput
                                v-model="clientInfo.name"
                                :placeholder="$t('fromData.name')"
                                maxlength="32"
                        ></ElInput>
                    </ElFormItem>
                </ElCol>
                <ElCol :xs="{span:20,push:2}" :sm="12" :md="12" :lg="12" :xl="12">
                    <ElFormItem :label="$t('fromData.position')" prop="position">
                        <ElInput
                                v-model="clientInfo.position"
                                :placeholder="$t('fromData.position')"
                                maxlength="128"
                        ></ElInput>
                    </ElFormItem>
                </ElCol>
            </ElRow>
            <ElRow :gutter="20">
                <ElCol :xs="{span:20,push:2}" :sm="24" :md="24" :lg="24" :xl="24">
                    <ElFormItem :label="$t('fromData.company')" prop="company">
                        <ElInput
                                v-model="clientInfo.company"
                                :placeholder="$t('fromData.company')"
                                maxlength="128"
                        ></ElInput>
                    </ElFormItem
                    >
                </ElCol>
            </ElRow>
            <ElRow :gutter="20">
                <ElCol :xs="{span:20,push:2}" :sm="12" :md="12" :lg="12" :xl="12">
                    <ElFormItem :label="$t('fromData.email')" prop="email">
                        <ElInput
                                v-model="clientInfo.email"
                                :placeholder="$t('fromData.email')"
                                type="email"
                                maxlength="128"
                        ></ElInput>
                    </ElFormItem
                    >
                </ElCol>
                <ElCol :xs="{span:20,push:2}" :sm="12" :md="12" :lg="12" :xl="12">
                    <ElFormItem :label="$t('fromData.phone')" prop="phone">
                        <ElInput
                                v-model="clientInfo.phone"
                                :placeholder="$t('fromData.phone')"
                                maxlength="128"
                        ></ElInput>
                    </ElFormItem
                    >
                </ElCol>
            </ElRow>
        </ElForm>
        <div class="more-btn">
            <ElButton v-show="!isMore" size="small" type="primary" @click="onShowMore"> {{$t('fromData.more')}}
            </ElButton>
        </div>
        <!-- 展开form信息 -->
        <ElForm
                label-position="top"
                :model="detailForm"
                class="demo-form-inline"
                v-show="isMore"
                ref="detailForm"
        >
            <ElRow :gutter="20">
                <ElCol :xs="{span:10,push:2}" :sm="10" :md="6" :lg="6" :xl="6">
                    <ElFormItem :label="$t('fromData.productName')">
                        <ElInput
                                v-model="detailForm.productName"
                                :placeholder="$t('fromData.productName')"
                                maxlength="128"
                        ></ElInput>
                    </ElFormItem>
                </ElCol>
                <ElCol :xs="{span:10,push:2}" :sm="10" :md="6" :lg="6" :xl="6">
                    <ElFormItem :label="$t('fromData.productType')">
                        <ElInput
                                v-model="detailForm.productType"
                                :placeholder="$t('fromData.productType')"
                                maxlength="128"
                        ></ElInput>
                    </ElFormItem>
                </ElCol>
                <ElCol :xs="{span:10,push:2}" :sm="10" :md="6" :lg="6" :xl="6">
                    <ElFormItem :label="$t('fromData.origin')">
                        <ElInput
                                v-model="detailForm.origin"
                                :placeholder="$t('fromData.origin')"
                                maxlength="128"
                        ></ElInput>
                    </ElFormItem
                    >
                </ElCol>
                <ElCol :xs="{span:10,push:2}" :sm="10" :md="6" :lg="6" :xl="6">
                    <ElFormItem :label="$t('fromData.newOrGeneric')">
                        <ElInput
                                v-model="detailForm.newOrGeneric"
                                :placeholder="$t('fromData.newOrGeneric')"
                                maxlength="128"
                        ></ElInput>
                    </ElFormItem
                    >
                </ElCol>
            </ElRow>
            <ElRow :gutter="20">
                <ElCol :xs="{span:20,push:2}" :sm="24" :md="24" :lg="24" :xl="24">
                    <ElFormItem :label="$t('fromData.cureSphere')">
                        <ElInput
                                v-model="detailForm.cureSphere"
                                :placeholder="$t('fromData.cureSphere')"
                                maxlength="128"
                        ></ElInput>
                    </ElFormItem>
                </ElCol>
            </ElRow>
            <ElRow :gutter="20">
                <ElCol :xs="{span:20,push:2}" :sm="24" :md="24" :lg="24" :xl="24">
                    <ElFormItem :label="$t('fromData.indication')">
                        <ElInput
                                v-model="detailForm.indication"
                                :placeholder="$t('fromData.indication')"
                                maxlength="128"
                        ></ElInput>
                    </ElFormItem>
                </ElCol>
            </ElRow>
            <ElRow :gutter="20">
                <ElCol :xs="{span:20,push:2}" :sm="24" :md="24" :lg="24" :xl="24">
                    <ElFormItem :label="$t('fromData.indicationZh')">
                        <ElInput
                                v-model="detailForm.indicationZh"
                                :placeholder="$t('fromData.indicationZh')"
                                maxlength="128"
                        ></ElInput>
                    </ElFormItem>
                </ElCol>
            </ElRow>
            <ElRow :gutter="20">
                <ElCol :xs="{span:20,push:2}" :sm="12" :md="12" :lg="12" :xl="12">
                    <ElFormItem :label="$t('fromData.stage')">
                        <ElInput
                                v-model="detailForm.stage"
                                :placeholder="$t('fromData.stage')"
                                maxlength="128"
                        ></ElInput>
                    </ElFormItem>
                </ElCol>
                <ElCol :xs="{span:20,push:2}" :sm="12" :md="12" :lg="12" :xl="12">
                    <ElFormItem :label="$t('fromData.cooperativeIntention')">
                        <ElInput
                                v-model="detailForm.cooperativeIntention"
                                :placeholder="$t('fromData.cooperativeIntention')"
                                maxlength="128"
                        ></ElInput>
                    </ElFormItem>
                </ElCol>
            </ElRow>
            <ElRow :gutter="20">
                <ElCol :xs="{span:20,push:2}" :sm="24" :md="24" :lg="24" :xl="24">
                    <ElFormItem :label="$t('fromData.remark')">
                        <ElInput
                                v-model="detailForm.remark"
                                :placeholder="$t('fromData.remark')"
                                maxlength="128"
                        ></ElInput>
                    </ElFormItem>
                </ElCol>
            </ElRow>
            <ElRow :gutter="20">
                <ElCol :xs="{span:22,push:1}" :sm="24" :md="24" :lg="24" :xl="24">
                    <p class="note">
                        {{$t('fromData.moreText')}}
                    </p>
                </ElCol>
            </ElRow>
            <ElRow :gutter="20">
                <ElCol :xs="{span:20,push:2}" :sm="12" :md="8" :lg="8" :xl="8">
                    <ElFormItem :label="$t('fromData.captcha')">
                        <div class="captcha-row">
                            <ElInput
                                    v-model="captchaCode"
                                    :placeholder="$t('fromData.captcha')"
                                    maxlength="6"
                                    @keyup.enter.native="submitForm"
                            ></ElInput>
                            <img
                                    class="captcha-img"
                                    v-if="captchaImg"
                                    :src="captchaImg"
                                    :title="$t('fromData.captcha')"
                                    @click="getCaptcha"
                            >
                        </div>
                    </ElFormItem>
                </ElCol>
            </ElRow>
            <ElRow :gutter="20">
                <ElCol :xs="{span:20,push:2}" :sm="24" :md="24" :lg="24" :xl="24">
                    <ElFormItem label="">
                        <ElButton type="primary" class="sub-btn" :loading="submitting" @click="submitForm"> {{$t('fromData.btnText')}}
                        </ElButton>
                    </ElFormItem>
                </ElCol
                >
            </ElRow>
        </ElForm>
        <!-- 提醒弹框 -->
        <el-dialog
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                :modal="false"
                top="20vh"
        >
            <span slot="title"></span>
            <div class="dialog-content">
                <p>{{$t('fromData.sendOk')}}</p>
                <p>{{$t('fromData.sendText')}}</p>
            </div>
            <span slot="footer" class="dialog-footer"></span>
        </el-dialog>
    </div>
</template>
<script>
    import {PostCooperate, GetCaptchaImage} from '../api/web'

    export default {
        props: {
            isTitle: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                // dribbble
                clientInfo: {
                    name: "",
                    position: "",
                    company: "",
                    email: "",
                    phone: "",
                    companyId: 1,
                },
                //   客户信息校验
                clientRules: {
                    name: [{required: true, message: " ", trigger: "blur"}],
                    position: [{required: true, message: " ", trigger: "blur"}],
                    company: [{required: true, message: " ", trigger: "blur"}],
                    email: [{required: true, message: " ", trigger: "blur"}],
                    phone: [{required: true, message: " ", trigger: "blur"}],
                },
                detailForm: {
                    productName: "",
                    productType: "",
                    origin: "",
                    newOrGeneric: "",
                    cureSphere: "",
                    indication: "",
                    indicationZh: '',
                    stage: "",
                    cooperativeIntention: "",
                    remark: "",
                },
                isMore: false, //显示更多
                dialogVisible: false,
                submitting: false, // 提交中，防止重复提交
                captchaImg: "", // 图形验证码base64
                captchaUuid: "", // 图形验证码uuid
                captchaCode: "" // 用户输入的验证码
            };
        },
        computed: {
            type() {
                return this.$route.query.type
            }
        },
        mounted() {
            this.getCaptcha();
            this.type && this.onScroll();
        },
        watch: {
            type(n) {
                this.type && this.onScroll();
            }
        },
        methods: {
            // 跳到指定位置
            onScroll() {
                document.getElementById('form').scrollIntoView(true)
            },
            // 获取图形验证码
            getCaptcha() {
                GetCaptchaImage().then(res => {
                    if (res.status && res.data) {
                        this.captchaImg = "data:image/jpg;base64," + res.data.img;
                        this.captchaUuid = res.data.uuid;
                        this.captchaCode = "";
                    }
                }).catch(() => {});
            },
            //   同意并发送
            submitForm() {
                if (this.submitting) {
                    return;
                }
                this.$refs.clientInfo.validate((valid) => {
                    if (valid) {
                        if (!this.captchaCode || !this.captchaCode.trim()) {
                            this.$notify.error({
                                title: this.$t("fromData.error"),
                                message: this.$t("fromData.captchaEmpty"),
                            });
                            this.getCaptcha();
                            return;
                        }
                        this.submitting = true;
                        let _obj = {...this.clientInfo, ...this.detailForm, companyId: 2,
                            captchaUuid: this.captchaUuid, captchaCode: this.captchaCode.trim()};
                        PostCooperate(_obj).then(res => {
                            this.submitting = false;
                            if (res.status) {
                                this.dialogVisible = true;
                                setTimeout(() => {
                                    this.dialogVisible = false;
                                }, 3000)
                                this.$refs['clientInfo'].resetFields();
                                this.detailForm = {
                                    productName: "",
                                    productType: "",
                                    origin: "",
                                    newOrGeneric: "",
                                    cureSphere: "",
                                    indication: "",
                                    indicationZh: '',
                                    stage: "",
                                    cooperativeIntention: "",
                                    remark: "",
                                };
                                this.isMore = false;
                            } else {
                                this.$notify.error({
                                    title: this.$t("fromData.error"),
                                    message: res.msg || '系统错误'
                                });
                            }
                            // 验证码一次性使用，无论成败都刷新
                            this.getCaptcha();
                        }).catch(() => {
                            this.submitting = false;
                            this.getCaptcha();
                        });
                    } else {
                        this.$notify.error({
                            title: this.$t("fromData.error"),
                            message: this.$t("fromData.fromRules"),
                        });
                        return false;
                    }
                });
            },
            onShowMore() {
                this.isMore = true;
            },
        },
    };
</script>
<style lang="less" scoped>
    @import "../style/constant";

    @media screen and (max-width: 996px) {
        /deep/ .el-dialog {
            width: 80% !important;
        }
    }

    .form {
        width: 100%;
        max-width: 1100px;
        margin: 0 auto;
        padding: 120px 0 40px;
        font-weight: bold;
        overflow: hidden;

        .title {
            text-align: center;
            margin-bottom: 40px;
        }

        .more-btn {
            padding-bottom: 20px;
            display: flex;
            justify-content: center;
        }

        .note {
            margin-bottom: 30px;
            color: @content-color;
            font-size: 13px;
        }

        .sub-btn {
            &:hover {
                background-color: @from-icon-color;
                border: 1px solid @from-icon-color;
            }
        }

        .captcha-row {
            display: flex;
            align-items: center;

            .captcha-img {
                height: 40px;
                margin-left: 8px;
                cursor: pointer;
                border: 1px solid #A6A6A6;
                flex-shrink: 0;
            }
        }
    }
    @media screen and (max-width: 996px) {
		.form {
            padding: 40px 0 40px;
            .title {
                margin-bottom: 30px;
            }
		}
	}

    .el-dialog {
        width: 40vw;

        .dialog-content {
            font-size: 28px;
            padding: 60px 30px;
            text-align: center;
            line-height: 60px;
        }
    }


    // element-form样式
    /deep/ .el-form-item__label {
        color: @from-icon-color;
        font-size: 14px;
        font-weight: 400;
        line-height: normal;
        padding: 0;
    }

    /deep/ .el-input__inner {
        background: #F3F3F7;
        border: 1px solid #A6A6A6;
        border-radius: 0;
    }

    /deep/ .el-form-item.is-error .el-input__inner,
    .el-form-item.is-error .el-input__inner:focus,
    .el-form-item.is-error .el-textarea__inner,
    .el-form-item.is-error .el-textarea__inner:focus,
    .el-message-box__input input.invalid,
    .el-message-box__input input.invalid:focus {
        box-shadow: inset 2px 0 0 0 #e04562;
        border-width: 0;
    }

    /deep/ .forminator-custom-form-10166.forminator-design--flat .forminator-input,
    .forminator-custom-form-10166.forminator-design--flat .forminator-input:hover,
    .forminator-custom-form-10166.forminator-design--flat .forminator-input:focus,
    .forminator-custom-form-10166.forminator-design--flat .forminator-input:active {
        background-color: #ededed;
        color: @h1-color;
        font-size: 16px;
        font-family: inherit;
        font-weight: 400;
    }

    /deep/ .el-button--primary {
        background-color: @active-color;
        color: #ffffff;
        border: 1px solid @active-color;
        border-radius: 0;
    }

    /deep/ .el-form-item__error {
        width: 100%;
        line-height: 30px;
        background-color: #f9e4e8;
        color: @active-color;
        margin: 5px 0 0;
        // padding-left: 15px;
    }
</style>
